import HttpService from "@/services/HttpService";
const httpService = new HttpService();

export default class OwnerService {
  /**
   * Get an owner by their id
   * @param id
   * @returns
   */
  getOwnerByid: any = async (id: string) => {
    return await httpService
      .fetch("GET", `api/owner/web/check/${id}`, {})
      .then((owner) => {
        console.log("get owner resposne", owner);
        if (owner.exists) {
          return { exists: true, data: owner };
        } else {
          return { exists: false };
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  /**
   * Get an owner data by their verification token
   * That they got from the signing up email
   * @param token
   * @returns
   */
  getOwnerByVerificationToken: any = async (token: string) => {
    return await httpService
      .fetch("GET", `api/owner/web/emailverification/${token}`, {})
      .then((serverResponse) => {
        if (serverResponse.exists) {
          return { exists: true, owner: serverResponse.owner };
        } else {
          return { exists: false };
        }
      })
      .catch((err) => {
        return { exists: false, error: err };
      });
  };

  /**
   *
   * @param firstname
   * @param lastname
   * @param companyAddress
   * @param token
   */
  verifyAccount: any = async (
    firstname: string,
    lastname: string,
    companyAddress: string,
    token: string
  ) => {
    console.log("verify account");
    return await httpService
      .fetch("POST", "api/owner/web/verifyAccount", {
        firstname,
        lastname,
        address: companyAddress,
        token,
      })
      .then((serverResponse) => {
        console.log("serverResponse", serverResponse);
        localStorage.setItem("authToken", serverResponse.token);
        localStorage.setItem("owner", JSON.stringify(serverResponse.owner));
      })
      .catch((err) => {
        return { success: false, error: err };
      });
  };

  /**
   * Logout the connected owner
   */
  logoutOwner: any = async () => {
    localStorage.removeItem("owner");
    localStorage.removeItem("admin");
    localStorage.removeItem("authToken");
  };

  /**
   * create an owner account
   * @param email
   * @param password
   */
  connectOwner: any = async (email: string, password: string) => {
    return await httpService
      .fetch("POST", "api/owner/web/connect", {
        owner: {
          email: email,
          password: password,
        },
      })
      .then((result) => {
        console.log("result from login", result);
        let errorMessage = "errors.general.generalError";
        if (!result.success) {
          // i18n
          switch (result.error) {
            case "INCORRECT_PWD":
              errorMessage = "errors.login.incorrectPwd";
              break;
            case "NOT_EXISTS":
              errorMessage = "errors.login.notExists";
              break;

            default:
              break;
          }

          return { success: false, message: errorMessage };
        } else {
          localStorage.setItem("authToken", result.token);
          localStorage.setItem("owner", JSON.stringify(result.owner));
          return { success: true };
        }
      });
  };

  /**
   * signup an oswner
   * @param email
   * @param password
   */
  signupOwner: any = async (email: string, password: string) => {
    console.log("sign up owner");
    return await httpService
      .fetch("POST", "api/owner/web/signup", {
        owner: {
          email: email,
          password: password,
        },
      })
      .then((result) => {
        console.log("result from signup", result);
        let errorMessage = "errors.general.generalError";
        if (!result.success) {
          // i18n
          switch (result.error) {
            case "ALREADY_EXISTS":
              errorMessage = "errors.signup.alreadyRegistred";
              break;

            default:
              break;
          }

          return { success: false, message: errorMessage };
        } else {
          localStorage.setItem("authToken", result.token);
          localStorage.setItem("owner", JSON.stringify(result.owner));
          return { success: true };
        }
      });
  };

  /**
   * bring an owner to the stripe portal so they can manage their subscriptions
   * @param customerId
   */
  goToStripePortal: any = async (customerId: string) => {
    console.log("go to stripe portal withcustomer id", customerId);

    const serverResponse = await httpService.fetch(
      "POST",
      "api/owner/web/stripePortal",
      { customerId }
    );
    if (serverResponse.redirect) {
      window.location.href = serverResponse.redirect;
    }
  };

  /**
   * Get the invoices of a given customer
   * @param customerId
   * @returns
   */
  getOwnersInvoices: any = async (ownerId: string, customerId: string) => {
    console.log("get invoices of customer", customerId);

    const serverResponse = await httpService.fetch(
      "GET",
      `api/payment/invoices/customer/${customerId}/owner/${ownerId}`,
      {}
    );

    console.log("serverResponse", serverResponse);

    if (serverResponse.success) {
      return serverResponse.invoices;
    } else {
      return [];
    }
  };
}
